/* Copyright (c) 2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { ObservableQuery } from "@apollo/client";
import { Button } from "@nordcloud/gnui";
import { CustomerForm } from "~/views/customers/components/Form/CustomerForm";

type CustomerProps = {
  refetch: ObservableQuery["refetch"];
};

function CustomerItem({ refetch }: CustomerProps) {
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

  return (
    <>
      <Button
        css={{ marginLeft: "auto" }}
        onClick={() => setIsSidebarOpen(true)}
        icon="plus"
      >
        Add Customer
      </Button>
      <CustomerForm
        refetch={refetch}
        customer={undefined}
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={() => setIsSidebarOpen(false)}
      />
    </>
  );
}

export { CustomerItem };
